module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    attrs: {
      "src": require("./brand.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("医点通 (北京) 信息技术有限公司提供技术支持")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38768c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iBrand/iBrand.vue
// module id = 789
// module chunks = 10